'use strict';

export const FORM_LIST_NAME = 'forms';
export const FORM_LIST_PREFIX = `@@${FORM_LIST_NAME}`;

export const UPDATE_SINGLE_FORM_RESPONSE_NAME = 'updateSingleFormResponse';
export const UPDATE_SINGLE_FORM_RESPONSE_PREFIX = `@@${UPDATE_SINGLE_FORM_RESPONSE_NAME}`;

export const FORM_EXPORT_REQ_NAME = 'formExportReqs';
export const FORM_EXPORT_REQ_PREFIX = `@@${FORM_EXPORT_REQ_NAME}`;



// WEBPACK FOOTER //
// ./src/js/forms/redux/state.js